import { FC, Fragment, useEffect, useState } from 'react'
import { CheckboxList } from 'packages/eid-ui'
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core'
import { IMitigatingControl } from 'types'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@material-ui/lab'
import { useItemMitigatingControlsRequestView } from 'hooks'

const useStyles = makeStyles(
    createStyles({
        root: {
            paddingTop: '12px',
            paddingBottom: '12px',
        },
        title: {
            fontSize: '12px',
            fontWeight: 'bold',
            lineHeight: 1.1,
            color: '#9b9b9b',
            textTransform: 'uppercase',
        },
        listItemsContainer: {
            marginLeft: '3px',
        },
    }),
)

export interface MitigationControlListProps {
    currentApprovalStepId: string
    onChange: (selected: IMitigatingControl[]) => void
}

const MitigationControlList: FC<MitigationControlListProps> = (props) => {
    const { t } = useTranslation()

    const classes = useStyles()

    const { data, isLoading } = useItemMitigatingControlsRequestView(
        props.currentApprovalStepId,
    )

    const [selectedItems, setSelectedItems] = useState([])

    const handleChange = (item: any) => {
        const currentIndex = selectedItems.findIndex(
            (i: any) => i.id === item.id,
        )
        const newChecked: any = [...selectedItems]

        if (currentIndex === -1) {
            newChecked.push(item)
        } else {
            newChecked.splice(currentIndex, 1)
        }

        setSelectedItems(newChecked)
    }

    useEffect(() => {
        props.onChange(selectedItems)
    }, [selectedItems])

    return (
        <Box className={classes.root}>
            <Typography className={classes.title}>
                {t('MyTasks_SelectMitigationControl')}{' '}
                <Box component={'span'} color={'#D0021b'}>
                    *
                </Box>
            </Typography>

            <Box className={classes.listItemsContainer}>
                {isLoading || !data ? (
                    <Skeleton height={40} />
                ) : data.length === 0 ? (
                    <Fragment>{t('MyTasks_NoDataFound')}</Fragment>
                ) : (
                    <CheckboxList
                        dataList={data}
                        checked={selectedItems}
                        handleToggle={handleChange}
                    />
                )}
            </Box>
        </Box>
    )
}

export default MitigationControlList
